export default "__VITE_ASSET__DU45O6Ob__"